<template>
  <div class="container-fluid">
    <h2>Chat Bot - Konfiguration</h2>
    <br/>
    <div class="btn-toolbar justify-content-between" role="toolbar">
      <div class="btn-group">
        <button @click="startBot" class="btn btn-primary"><font-awesome-icon icon="play"/>&nbsp;Starten</button>
        <button @click="stopBot"  class="btn btn-secondary"><font-awesome-icon icon="stop"/>&nbsp;Stoppen</button>
      </div>
      <button @click="reload"  class="btn btn-secondary"><font-awesome-icon icon="redo"/>&nbsp;Neu laden</button>
      <ChatBotStatus/>
    </div>
    <b-tabs class="mt-3">
      <b-tab title="Nachrichten">
        <ChatBotMsgHistory/>
      </b-tab>
      <b-tab title="Endpunkte">
        <ChatBotClientConfig/>
      </b-tab>
      <b-tab title="Aktionen">
        <ChatBotCommands/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import chatbot from '@/modules/chatbot.js'
import ChatBotMsgHistory from '@/components/digitalfirm/chatbot/ChatBotMsgHistory.vue'
import ChatBotClientConfig from '@/components/digitalfirm/chatbot/ChatBotClientConfig.vue'
import ChatBotCommands from '@/components/digitalfirm/chatbot/ChatBotCommands.vue'
import ChatBotStatus from '@/components/digitalfirm/chatbot/ChatBotStatus.vue'

export default {
  name: 'iHandConfig',
  components: {
    ChatBotStatus,
    ChatBotCommands,
    ChatBotMsgHistory,
    ChatBotClientConfig,
  },
  methods: {
    reload: function() {
      var self = this;
      chatbot.reload(this,function() {
        self.$bvToast.toast('Befehle werden neu geladen.',{title:'Chat Bot',variant: 'success'})        
      })
    },
    startBot: function() {
      var self = this;
      chatbot.startbot(this,function() {
        self.$bvToast.toast('Chat Bot wird gestartet.',{title:'Chat Bot',variant: 'success'})
      })
    },
    stopBot: function() {
      var self = this;
      console.log('stop bot');
      chatbot.stopbot(this,function() {
        self.$bvToast.toast('Chat Bot wird gestoppt.',{title:'Chat Bot',variant: 'success'})
      })
    },
  }
}
</script>
